// Lumly — product page: Descrizione/Scheda tecnica tabs + quote-request dialog
document.addEventListener('click', function (event) {
  var tabBtn = event.target.closest('[data-tab]');
  if (tabBtn) {
    var wrap = tabBtn.closest('[data-lumly-tabs]');
    if (!wrap) return;
    wrap.querySelectorAll('.lumly-ptabs__btn').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
    });
    tabBtn.classList.add('is-active');
    tabBtn.setAttribute('aria-selected', 'true');
    wrap.querySelectorAll('.lumly-ptabs__panel').forEach(function (panel) {
      var active = panel.getAttribute('data-panel') === tabBtn.getAttribute('data-tab');
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    return;
  }

  var openBtn = event.target.closest('[data-lumly-quote-open]');
  if (openBtn) {
    var dialog = document.getElementById(openBtn.getAttribute('data-lumly-quote-open'));
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var sectionId = dialog.getAttribute('data-section');
    var scope = sectionId ? document.querySelector('[data-section="' + sectionId + '"]') : null;
    var parts = [];
    if (scope) {
      scope.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        var checked = fieldset.querySelector('input:checked');
        if (legend && checked) {
          var label = legend.textContent.trim().split(':')[0].trim();
          parts.push(label + ': ' + checked.value);
        }
      });
    }
    var variantField = dialog.querySelector('[name="contact[Variante selezionata]"]');
    if (variantField) {
      variantField.value = parts.length ? parts.join(', ') : 'Variante unica';
    }

    dialog.showModal();
    return;
  }

  var closeBtn = event.target.closest('[data-lumly-quote-close]');
  if (closeBtn) {
    var openDialog = closeBtn.closest('dialog');
    if (openDialog) openDialog.close();
  }
});
